export enum FeatureFlags {
  // PAC
  PACIMNEHP = 'PACIMNEHP',
}
